import BaseModel from "../BaseModel";
import EnvironmentType from "./EnvironmentType";

export default class Environment extends BaseModel{
    static entity = 'environments';
    static fields(){
        return {
            id: this.attr(null),
            customer_id: this.attr(null),
            environment_type_id: this.attr(null),
            user_id: this.attr(null),
            environment_type: this.belongsTo(EnvironmentType, 'environment_type_id')
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'environment_type']
    }
    static route(){
        return '/environments'
    }
}
